export default {
  default: () => import("/app/src/layouts/default.vue").then(m => m.default || m),
  event: () => import("/app/src/layouts/event.vue").then(m => m.default || m)
}